const formattedQuestionType = (question_type) => {
    switch (question_type) {
        case 'fill_in_the_blank':
            return 'Fill In The Blank / Inline Choice'
        case 'new_select_all_that_apply':
            return 'Check All That Apply / Multiselect'
        default:
            return question_type.replace(/_/g, ' ')
    }
};

export {formattedQuestionType}
